import styled from "styled-components";
import { devices } from '../../../../src/globalStyle'

export const Content = styled.div`
  width: 100%;
  margin-top: 1rem;
  overflow-y: auto;
  font-family: 'Inter', sans-serif;
  min-height: 70vh;
  max-height: 70vh;

  /* Estilos do scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const FilterDiv = styled.div`
  display: flex;
  width: 7vw;
  border: 1.6px solid #0090d3;
  background-color: #fff;
  border-radius: 1.5vw;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 5vw;
    height: 4vh;
  }
`

export const FilterImg = styled.img`
  margin-left: 0.7vw;
  height: 4vh;
  @media ${devices.largeDesktop} {
    margin-left: 0.4vw;
    height: 3vh;
  }
`

export const FilterText = styled.h2`
  margin-left: 0.3vw;
  font-size: 0.95vw;
  color: #0090d3;

  @media ${devices.largeDesktop} {
    margin-left: 0.2vw;
    font-size: 0.75vw;
  }
`

export const Select = styled.select`
  width: 12.5rem;
  height: 2.5rem;
  border-radius: 20px;
  border: none;
  background-color: #EBEBEB;
`

export const NewOPButton = styled.button`
  width: 9.75rem;
  height: 2.5rem;
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 14px;
  background-color: #0090D3;
  color: #FFFFFF;
  border-radius: 20px;
  border: none;
`